/* eslint-disable react-hooks/exhaustive-deps */
import {
  FunctionComponent,
  useEffect,
  useState,
  useCallback,
  useRef,
} from 'react'
import { MdAdd } from 'react-icons/md'
import { useHistory } from 'react-router-dom'
import { Grid } from '@material-ui/core'

import Buscar from 'shared/components/Buscar'
import { IValueBuscar } from 'shared/components/Buscar/BuscarComponent.types'
import Excluir from 'shared/components/Excluir'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import Modal from 'shared/components/Modal'
import SnackBar from 'shared/components/SnackBar'
import Text from 'shared/components/Text'
import { convertDateToStringBrazilianPattern } from 'shared/utils/formatters'
import ContainerPage from 'shared/components/ContainerPageNew'
import Pagination from 'shared/components/Pagination'
import { colors } from 'shared/styles/colors'
import Table from 'shared/components/Table'
import { IGetImagemMotorista } from 'modules/motorista/domain/usecases/GetImagemMotorista'
import { useFrotista } from 'modules/user/hooks/useFrotista'

import IFindAllMotoristaRequest from '../../domain/entities/IFindAllMotoristasRequest'
import IMotorista from '../../domain/entities/IMotorista'
import { IDeleteMotorista } from '../../domain/usecases/DeleteMotorista'
import { IFindByCpfNomeFrotistaId } from '../../domain/usecases/FindByCpfNomeFrotistaId'
import DetalhesMotorista from './DetalhesMotorista'
import { StyledGrid } from './styles'

type TProp = {
  findByCpfNomeFrotistaId: IFindByCpfNomeFrotistaId
  deleteMotorista: IDeleteMotorista
  getImagemMotorista: IGetImagemMotorista
}

const ListMotoristas: FunctionComponent<TProp> = ({
  findByCpfNomeFrotistaId,
  deleteMotorista,
  getImagemMotorista,
}) => {
  const history = useHistory()
  const [motoristas, setMotoristas] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')
  const [error, setError] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [recordsPerPage, setRecordsPerPage] = useState(10)
  const [search, setSearch] = useState(null)
  const [openDetails, setOpenDetails] = useState(false)
  const [selectedMotorista, setSelectedMotorista] = useState<IMotorista>(
    {} as IMotorista,
  )
  const [openModalDeletar, setOpenModalDeletar] = useState(false)
  const [idSelecionado, setIdSelecionado] = useState(null)
  const [deletado, setDeletado] = useState(false)
  const [openModalImage, setOpenModalImage] = useState(false)
  const [urlImagemModal, setUrlImagemModal] = useState('')
  const [protocoloImagemModal, setProtocoloImagemModal] = useState('')
  const { frotistaId } = useFrotista()

  const handleView = motorista => {
    setOpenDetails(true)
    setSelectedMotorista(motorista)
  }

  const handleEdit = motorista => {
    history.push('/motoristas/edit', { params: motorista })
  }

  const handleImageModal = useCallback(
    async (id: number, protocolo: string) => {
      try {
        const response = await getImagemMotorista.execute(id)
        setUrlImagemModal(response)
        setProtocoloImagemModal(protocolo)
        setOpenModalImage(true)
      } catch (error: unknown) {
        if (error instanceof Error) {
          setErrorMessage(error.message)
        } else {
          setErrorMessage(
            'Erro ao tentar buscar a doc do motorista anexo da ocr.',
          )
        }
        setError(true)
      }
    },
    [],
  )

  const handleDelete = (id: number) => {
    setOpenModalDeletar(true)
    setIdSelecionado(id)
  }

  const [loading, setLoading] = useState(false)
  const inputMotoristaRef = useRef(null)
  const handleGetMotoristas = useCallback(
    (query: IFindAllMotoristaRequest) => {
      return findByCpfNomeFrotistaId.execute(query)
    },
    [findByCpfNomeFrotistaId],
  )
  const fetchMotoristas = async (page: number, search: string) => {
    setSearch(search)
    setLoading(true)
    try {
      const response = await handleGetMotoristas({
        page,
        perPage: 10,
        nome: search,
        list_status: ['VALID', 'MANUAL_APPROVAL', 'INVALID', 'MANUAL_REPROVAL'],
        frotista_id: frotistaId ? Number(frotistaId) : undefined,
      })
      const newMotoristas = response.data.map(item => {
        return {
          ...item,
          vencimento_cnh: convertDateToStringBrazilianPattern(
            item.vencimento_cnh,
          ),
          cnpj_frotista: item?.frotista?.cnpj || '',
          handleView: () => handleView(item),
          handleEdit: () => handleEdit(item),
          handleImageModal: () => handleImageModal(item.id, item.protocolo_ocr),
          handleDelete: () => handleDelete(item.id),
        }
      })
      setMotoristas(newMotoristas)
      setTotalRecords(response.total)
      setRecordsPerPage(response.per_page)
      setLoading(false)
    } catch (err: unknown) {
      setError(true)
      if (err instanceof Error) {
        setErrorMessage(err.message)
      } else {
        setErrorMessage('Erro buscar motoristas')
      }
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchMotoristas(currentPage, search)
  }, [currentPage, search, frotistaId])

  const handleSearch = async (values: IValueBuscar) => {
    setCurrentPage(1)

    values.valueInput !== '' ? setSearch(values.valueInput) : setSearch(null)
  }

  const handleCloseModal = () => {
    setOpenDetails(false)
  }

  const onCloseModal = () => {
    setOpenModalDeletar(false)
    setDeletado(false)
    setCurrentPage(1)
    fetchMotoristas(1, search !== '' ? search : null)
  }

  const onDeleteMotorista = async (id: number) => {
    setLoading(true)
    try {
      await deleteMotorista.execute(id, frotistaId)
      setDeletado(true)
      setLoading(false)
    } catch (e: unknown) {
      setError(true)
      if (e instanceof Error) {
        setErrorMessage(e.message)
      } else {
        setErrorMessage('Erro ao tentar deletar o motorista')
      }
      setLoading(false)
      onCloseModal()
    }
  }

  const handleNewMotorista = useCallback(() => {
    history.push('/motoristas/new')
  }, [])

  return (
    <>
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}
      {openDetails && (
        <DetalhesMotorista
          motorista={selectedMotorista}
          open={openDetails}
          setOpenModal={handleCloseModal}
        />
      )}
      <ContainerPage
        breadCrumb="Motoristas / Lista de motoristas"
        showFooterScaffold
        iconButtonNext={MdAdd}
        onClickNextButton={handleNewMotorista}
        titleNextButton="Adicionar"
        colorNextButton={`${colors.green}`}
        title="Lista de motorista(s)"
        titleHeader="Novo motorista"
      >
        <Modal
          size={'large'}
          showCloseButton={true}
          openModal={openModalImage}
          onCloseModal={() => {
            setOpenModalImage(false)
            setUrlImagemModal('')
            setProtocoloImagemModal('')
          }}
        >
          <Text size={14}>Protocolo Idwall</Text>
          <Text color={colors.grayDark} size={14} weight={'700'}>
            {protocoloImagemModal}
          </Text>
          <img
            src={`data:image/png;base64,${urlImagemModal}`}
            style={{ maxHeight: 500, maxWidth: 800, marginTop: 10 }}
            alt="Imagem do protocolo"
          />
        </Modal>
        <Grid container>
          <Grid item xs={12}>
            <Buscar
              handleSubmit={handleSearch}
              inputBuscarRef={inputMotoristaRef}
              placeholder="Digite o nome para buscar"
              label="Buscar motorista"
              loading={loading}
            />
          </Grid>
        </Grid>
        <StyledGrid container>
          <Grid item xs={12}>
            {motoristas && <Table data={motoristas} type="motorista" />}
          </Grid>
          <Grid item xs={12}>
            <SnackBar
              open={error}
              setOpen={setError}
              severity="error"
              message={errorMessage}
              horizontal="right"
            />
          </Grid>
        </StyledGrid>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          recordsPerPage={recordsPerPage}
          setCurrentPage={setCurrentPage}
        />
      </ContainerPage>
      <Excluir
        openModalDeletar={openModalDeletar}
        onCloseModal={onCloseModal}
        title={'Excluir motorista'}
        subTitle={'Tem certeza que deseja excluir este motorista da sua lista?'}
        deletado={deletado}
        titleDeletado={'Motorista excluído!'}
        idSelecionado={idSelecionado}
        onDelete={onDeleteMotorista}
      />
    </>
  )
}

export default ListMotoristas
